// Export payload for the shelf-family blocks, ported from the pptx / summary exporters. They
// describe the chart by what it plots rather than by the stored mode token, and read the view
// and collapse state that now lives in React.

const COLUMN_CHART_MODES = ['respondents', 'percents']
const BAR_CHART_MODES = ['brespondents', 'bpercents']
const PERCENT_CHART_MODES = ['pie', 'percents', 'bpercents']

export const calcExportData = ({
  viewMode,
  sortOrder,
  shelfViewMode,
  shelfCollapsed,
  chartCollapsed,
  chartMode
} = {}) => ({
  viewMode,
  sortOrder,
  shelfViewMode,
  shelfCollapsed,
  chartCollapsed,
  chartType: COLUMN_CHART_MODES.includes(chartMode)
    ? 'column'
    : BAR_CHART_MODES.includes(chartMode)
      ? 'bar'
      : chartMode,
  dataType: PERCENT_CHART_MODES.includes(chartMode) ? 'percents' : 'respondents'
})
